import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { RETRIEVE_TENANT_AGENCY_SALES_REP_APPROVAL_SETTINGS_API, TENANT_UPDATE_AGENCY_SALES_REP_ORDER_APPROVAL_SETTINGS_API } from '../../api/api_data';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_tenant_agency_sales_rep_approval_settings, loading_retrieve_tenant_agency_sales_rep_approval_settings, reset_retrieve_tenant_agency_sales_rep_approval_settings, success_retrieve_tenant_agency_sales_rep_approval_settings } from '../../reducers/auth_tenant/retrieve_tenant_agency_sales_rep_approval_settings_Slice';
import { useSelector } from 'react-redux';
import { getSelectedOption, messageToast } from '../../utils/Utils';
import * as app_consts from "../../utils/app_consts";
import { useDispatch } from 'react-redux';
import { TENANT_RETRIEVE_AGENCY_SALES_REP_APPROVAL_SETTINGS_ERROR_MSG, TENANT_RETRIEVE_AGENCY_SALES_REP_APPROVAL_SETTINGS_SUCCESS_MSG, TENANT_UPDATE_ORDER_APPROVERS_ERROR_MSG, TENANT_UPDATE_ORDER_APPROVERS_SUCCESS_MSG } from '../../utils/error_success_messages';
import TextInput from '../../pages/components/inputs/TextInput';
import { Icon, RSelect } from '../Component';
import { fail_tenant_update_order_approvers, loading_tenant_update_order_approvers, reset_tenant_update_order_approvers, success_tenant_update_order_approvers } from '../../reducers/auth_tenant/tenant_update_order_approvers_Slice';

const initial_state = { agency_id: "", sales_rep_id: "", type: "", first_approver: "", second_approver: "", approvers_type: [] };

const ViewApprovalSettingsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction, data }) => {

  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [form_data, setFormData] = useState(initial_state);
  const [update_loading, setUpdateLoading] = useState(false);
  const [update_error, setUpdateError] = useState("");
  const [current_sales_reps_data, setCurrentSalesRepsData] = useState([]);

  useEffect(() => {
    if (isOpen && data)
    {
      // Dispatch
      setEditMode(false);
      retrieve_agency_sales_rep_approval_settings();
      setError("");
    }
    setOpen(isOpen);
  }, [isOpen, data]);

  const retrieve_agency_sales_rep_approval_settings = () => {
    setError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_agency_sales_rep_approval_settings, success_retrieve_tenant_agency_sales_rep_approval_settings, fail_retrieve_tenant_agency_sales_rep_approval_settings, TENANT_RETRIEVE_AGENCY_SALES_REP_APPROVAL_SETTINGS_ERROR_MSG, TENANT_RETRIEVE_AGENCY_SALES_REP_APPROVAL_SETTINGS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_AGENCY_SALES_REP_APPROVAL_SETTINGS_API}/${data?.id}/${data?.agency_id}`));
  };
  // Listener
  const retrieve_tenant_agency_sales_rep_approval_settings_listener = useSelector((state) => state.retrieve_tenant_agency_sales_rep_approval_settings.retrieve_tenant_agency_sales_rep_approval_settings);

  useEffect(() => {
    if (retrieve_tenant_agency_sales_rep_approval_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_agency_sales_rep_approval_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_agency_sales_rep_approval_settings_listener.status === app_consts.FAIL)
        {
          setError(retrieve_tenant_agency_sales_rep_approval_settings_listener.message);
          messageToast(retrieve_tenant_agency_sales_rep_approval_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_agency_sales_rep_approval_settings_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_agency_sales_rep_approval_settings_listener.data);
        }
        setLoading(false);
        dispatch(reset_retrieve_tenant_agency_sales_rep_approval_settings());
      }
    }
  }, [retrieve_tenant_agency_sales_rep_approval_settings_listener]);

  const handle_id_one_change = (e) => {
    const new_mapped_data = page_data?.sales_reps?.filter((rep) => { return rep?.value !== e?.value; });
    setCurrentSalesRepsData(new_mapped_data);
    setFormData({ ...form_data, first_approver: e?.value, second_approver: "" });
  };

  const handleUpdateOrderApprovers = () => {
    setUpdateError("");
    // Dispatch
    const sent_data = { agency_id: data?.agency_id, sales_rep_id: data?.id, type: form_data?.type, first_approver: form_data?.first_approver, second_approver: form_data?.second_approver };
    dispatch(tenant_auth_actions_helper(loading_tenant_update_order_approvers, success_tenant_update_order_approvers, fail_tenant_update_order_approvers, TENANT_UPDATE_ORDER_APPROVERS_ERROR_MSG, TENANT_UPDATE_ORDER_APPROVERS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_AGENCY_SALES_REP_ORDER_APPROVAL_SETTINGS_API}`, sent_data));
  };

  // Listener
  const tenant_update_order_approvers_listener = useSelector((state) => state.tenant_update_order_approvers.tenant_update_order_approvers);

  useEffect(() => {
    if (tenant_update_order_approvers_listener.status !== app_consts.IDLE)
    {
      if (tenant_update_order_approvers_listener.status === app_consts.LOADING)
      {
        setUpdateLoading(true);
        setUpdateError("");
      } else
      {
        setUpdateLoading(false);
        if (tenant_update_order_approvers_listener.status === app_consts.FAIL)
        {
          setUpdateError(tenant_update_order_approvers_listener.message);
          messageToast(tenant_update_order_approvers_listener.message, app_consts.FAIL);
        } else if (tenant_update_order_approvers_listener.status === app_consts.SUCCESS)
        {
          messageToast(TENANT_UPDATE_ORDER_APPROVERS_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_agency_sales_rep_approval_settings();
          setEditMode(false);
        }
        dispatch(reset_tenant_update_order_approvers());
      }
    }
  }, [tenant_update_order_approvers_listener]);

  return (
    <>
      <Modal isOpen={open} toggle={loading ? "" : closeModal} className="modal-dialog-centered" size={"md"}>
        <ModalHeader toggle={loading ? "" : closeModal}>Approval Settings</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieving Approval Settings...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <div className='mt-4'>
                      </div>
                      {
                        editMode ?
                          <>
                            <Row className="g-4">
                              <Col lg={12}>
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      <label className="form-label mb text-md" htmlFor="retrunable">
                                        Approval Type<span className='text-danger pr-2'>{` *`}</span>
                                      </label>
                                    </label>
                                  </div>
                                  <div className="w-100">
                                    <RSelect
                                      options={page_data?.approvers_type}
                                      className="w-100"
                                      placeholder="Search"
                                      value={getSelectedOption(form_data?.type, page_data?.approvers_type)}
                                      onChange={(e) => setFormData({ ...form_data, type: e.value, first_approver: "", second_approver: "" })}
                                    />
                                  </div>
                                </div>
                                <Col lg={12}>
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <label className="form-label mb text-md" htmlFor="retrunable">
                                          First Approver<span className='text-danger pr-2'>{` *`}</span>
                                        </label>
                                      </label>
                                    </div>
                                    <div className="w-100">
                                      <RSelect
                                        options={page_data?.sales_reps}
                                        className="w-100"
                                        placeholder="Search"
                                        value={getSelectedOption(form_data?.first_approver, page_data?.sales_reps)}
                                        onChange={(e) => handle_id_one_change(e)}
                                        isDisabled={!form_data?.type}
                                      />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                              {
                                form_data?.type === app_consts.DOUBLE?.toLowerCase() && (
                                  <>
                                    <Col lg={12}>
                                      <div className="form-group">
                                        <div className="form-label-group">
                                          <label className="form-label">
                                            <label className="form-label mb text-md" htmlFor="retrunable">
                                              Second Approver<span className='text-danger pr-2'>{` *`}</span>
                                            </label>
                                          </label>
                                        </div>
                                        <div className="w-100">
                                          <RSelect
                                            options={current_sales_reps_data}
                                            isDisabled={!form_data?.first_approver}
                                            className="w-100"
                                            placeholder="Search"
                                            value={getSelectedOption(form_data?.second_approver, current_sales_reps_data)}
                                            onChange={(e) => { setFormData({ ...form_data, second_approver: e?.value }); }}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </>
                                )
                              }
                            </Row>
                            <hr />
                            <Row className="g-4 mt-4">
                              {update_error && (
                                <div className="mb-3 w-100">
                                  <Alert color="danger" className="alert-icon">
                                    <Icon name="alert-circle" /> {update_error}{" "}
                                  </Alert>
                                </div>
                              )}
                              <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                <Button className='mx-2' onClick={() => setEditMode(false)} disabled={update_loading} color="gray">
                                  Cancel
                                </Button>
                                <Button onClick={handleUpdateOrderApprovers} disabled={
                                  (update_loading) ||
                                  !(form_data?.type && form_data?.first_approver && (form_data?.type === "single" ? true : form_data?.second_approver))
                                } color="primary">
                                  {update_loading ? <Spinner size="sm" color="light" /> : "Update Approvers"}
                                </Button>
                              </Col>
                            </Row>
                          </>
                          :
                          <>
                            {
                              page_data?.settings ?
                                <>
                                  {(user_info?.roles?.includes(app_consts.UPDATE_AGENCY_SALES_REP_ORDER_APPROVALS) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                    <>
                                      <div className="m-auto d-flex flex-row justify-content-start align-center my-4" >
                                        <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData({ initial_state }); }} color="primary" size="sm">
                                          Edit Approvers
                                        </Button>
                                      </div>
                                    </>
                                  )}
                                  <Row className="g-4">
                                    <TextInput
                                      label="Type"
                                      type="text"
                                      id_val="type"
                                      value={page_data?.settings?.type || "--"}
                                      colSize="12"
                                      disabled
                                      name="type"
                                    />
                                    <TextInput
                                      label="First Approver"
                                      type="text"
                                      id_val="first_approver"
                                      value={page_data?.settings?.first_approver || "--"}
                                      colSize="12"
                                      disabled
                                      name="first_approver"
                                    />
                                    {
                                      page_data?.settings?.type?.toLowerCase() === app_consts.DOUBLE?.toLowerCase() && (
                                        <>
                                          <TextInput
                                            label="Second Approver"
                                            type="text"
                                            id_val="second_approval"
                                            value={page_data?.settings?.second_approver || "--"}
                                            colSize="12"
                                            disabled
                                            name="second_approval"
                                          />
                                        </>
                                      )
                                    }
                                  </Row>
                                </>
                                :
                                <>
                                  <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                                    <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>Order Approvers Have not Been Set</div>
                                    {(user_info?.roles?.includes(app_consts.UPDATE_AGENCY_SALES_REP_ORDER_APPROVALS) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                      <>
                                        <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData(initial_state); }} color="primary" size="sm">
                                          Add Approvers
                                        </Button>
                                      </>
                                    )}
                                  </div>
                                </>
                            }
                          </>
                      }

                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewApprovalSettingsModal;